export const CONFIRMED_RANKING_STORAGE_KEY = "streamfin_confirmed_ranking_by_market"

export interface ConfirmedRankingData {
    ranking_text: string
    cypher_query?: string
}

interface ConfirmedRankingState {
    /** Confirmed ranking per market key (e.g. FUNDOS). Drives display label/description for that market. */
    confirmedRankingByMarket: Record<string, ConfirmedRankingData>
    setConfirmedRanking: (market: string, data: ConfirmedRankingData) => void
    /** Merge server rankings into store (e.g. after list_rankings_per_market). */
    mergeConfirmedRankingsFromServer: (entries: Array<{ market: string; ranking_text: string; cypher_query: string }>) => void
    getConfirmedRanking: (market: string) => ConfirmedRankingData | undefined
}

export type { ConfirmedRankingState }
